import { z } from "zod";
import {
  ACCOUNT_NUMBER,
  BANK_NAME,
  CURRENCY,
  LEASE_DUE_DATE,
  MONTHLY_DUE_DATE,
  PHONE_1,
  PHONE_2,
  ROUTING_NUMBER,
  YEARLY_DUE_DATE,
} from "./consts";

export const schema = z.object({
  [YEARLY_DUE_DATE]: z
    .union([
      z.string().refine((val) => !val || !isNaN(Date.parse(val)), {
        message: "Invalid date format",
      }),
      z.date(),
    ])
    .optional(),
  [MONTHLY_DUE_DATE]: z.string().optional(),
  [LEASE_DUE_DATE]: z
    .union([
      z.string().refine((val) => !val || !isNaN(Date.parse(val)), {
        message: "Invalid date format",
      }),
      z.date(),
    ])
    .optional(),
  [CURRENCY]: z.string().optional(),
  [BANK_NAME]: z.string().optional(),
  [ROUTING_NUMBER]: z.string().optional(),
  [ACCOUNT_NUMBER]: z.string().optional(),
  [PHONE_1]: z.string().optional(),
  [PHONE_2]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
